import React from "react";

const SliderArticle = ({
  id,
  img,
  name,
  title,
  university,
  hobby,
  personIndex,
  Data,
  index,
}) => {
  let currentClass = "next-slide";
  if (personIndex === index) {
    currentClass = "active-slide";
  }
  if (
    personIndex === index - 1 ||
    (index === 0 && personIndex === Data.length - 1)
  ) {
    currentClass = "prev-slide";
  }
  return (
    <article key={id} className={`article ${currentClass}`}>
      <img src={img} alt={name} className="slider-img" />
      <div className="slider-text-part">
        <h3 className="slider-h3">{name}</h3>
        <div className="underlines"></div>
        <h4 className="slider-h4">{title}</h4>
        <h5 className="slider-h5">{university}</h5>
        <p className="slider-p">{hobby}</p>
      </div>
    </article>
  );
};

export default SliderArticle;
